import { render } from "./CpfModal.vue?vue&type=template&id=1ab70f32&scoped=true"
import script from "./CpfModal.vue?vue&type=script&lang=js"
export * from "./CpfModal.vue?vue&type=script&lang=js"

import "./CpfModal.vue?vue&type=style&index=0&id=1ab70f32&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ab70f32"]])

export default __exports__